/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  AddressDetails.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H224423
 *
 * @Date	     : 10 Apr, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : Added Modification History. ASDS-2497 - SIT Issue fixes. Added city in address and removed unneccessary comma's
 *
 * By            : H422335
 * On            : Sep 07 2020
 * Description   : ASDS-2743 - Review Order UI Enhancements as part of APU Phase 2.
 *
 ******************************************************************************/

import * as React from 'react';
import {
    Grid,
} from '@scuf/common';

// This is Common Component for Address details in Shipping and Billing Components.
import { IAddressDetailsProps } from '../utils/checkout-interfaces';

interface IAddressDetailsChildrenProps {
    children?: React.ReactNode;
}

function AddressDetails(props: IAddressDetailsProps & IAddressDetailsChildrenProps) {
    const {
        customerName,
        addrLine1 = '',
        addrLine2 = '',
        addrLine3 = '',
        city= '',
        country = '',
        state = '',
        zip = ''
    } = props.addressDetails;
    return (
        <Grid.Row>
            <Grid.Column width={11}>
                <div className="address">
                    <div><b>{customerName ? customerName : ''}</b></div>
                    {`${addrLine1 ? addrLine1 + ', ' : ''}${addrLine2 ? addrLine2 + ', ' : ''}${addrLine3 ? addrLine3 + ', ' : ''}${city ? city + ', ' : ''}${state ? state + ', ' : ''}${country ? country + ', ' : ''}${zip}`}
                    {props.children}
                </div>
            </Grid.Column>
        </Grid.Row>
    );
}

export default AddressDetails;